import { inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { PriceStore } from '../stores/price.store';
import { getFilterFromQueryParams } from '../components/analysis-price-filters/definitions';

export const priceLoadedGuard = (route: ActivatedRouteSnapshot) => {
  const priceStore = inject(PriceStore);

  // initialize filter from query params
  const filter = getFilterFromQueryParams(route);
  if (!priceStore.get(filter)) {
    priceStore.queue(filter);
  }

  return true;
};
